function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4292_4940)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.53845V3.5H7.03845V4.5H4V7.53845H3ZM3 21.5V17.4616H4V20.5H7.03845V21.5H3ZM16.9615 21.5V20.5H20V17.4616H21V21.5H16.9615ZM20 7.53845V4.5H16.9615V3.5H21V7.53845H20ZM16.9423 17.4423H18.1538V18.6538H16.9423V17.4423ZM16.9423 15.0192H18.1538V16.2308H16.9423V15.0192ZM15.7308 16.2308H16.9423V17.4423H15.7308V16.2308ZM14.5192 17.4423H15.7308V18.6538H14.5192V17.4423ZM13.3077 16.2308H14.5192V17.4423H13.3077V16.2308ZM15.7308 13.8077H16.9423V15.0192H15.7308V13.8077ZM14.5192 15.0192H15.7308V16.2308H14.5192V15.0192ZM13.3077 13.8077H14.5192V15.0192H13.3077V13.8077ZM18.1538 6.34615V11.1923H13.3077V6.34615H18.1538ZM10.6923 13.8077V18.6538H5.84615V13.8077H10.6923ZM10.6923 6.34615V11.1923H5.84615V6.34615H10.6923ZM9.8077 17.7692V14.6923H6.73077V17.7692H9.8077ZM9.8077 10.3077V7.23078H6.73077V10.3077H9.8077ZM17.2692 10.3077V7.23078H14.1923V10.3077H17.2692Z",
  fill: "white"
}));

function SvgIconScanQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4292_4940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _ref), _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanQr);
export default __webpack_public_path__ + "static/media/icon-scan-qr.59c06dc78f9ec2365b8c4c3a2293b327.svg";
export { ForwardRef as ReactComponent };